import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from './Navbar';

const Home = () => {
  const navigate = useNavigate();

  const handleAudioClick = () => {
    console.log('Navigating to AudioConverter...');
    navigate('audioconverter');
  };

  const handleVideoClick = () => {
    console.log('Navigating to VideotoAudio...');
    navigate('videotoaudio');
  };

  const handleVideo2VideoClick = () => {
    console.log('Navigating to VideotoVideo...');
    navigate('videotovideo');
  };

  return (
    <div className="home">
      <Navbar />
      <div className="hero-section">
        <div className="converters-container">
          <div className="converter-box audio-box">
            <div className="box-inner" onClick={handleAudioClick}>
              <span className="box-text">Audio Format Convert</span>
            </div>
          </div>
          <div className="converter-box videotovideo-box">
            <div className="box-inner" onClick={handleVideo2VideoClick}>
              <span className="box-text">Video Format Convert</span>
            </div>
          </div>
          <div className="converter-box video-box">
            <div className="box-inner" onClick={handleVideoClick}>
              <span className="box-text">Video to Audio Format Convert</span>
            </div>
          </div>
          
        </div>
      </div>

      <style jsx>{`
        .home {
          min-height: 100vh;
          width: 100%;
          background-color: white;
          overflow-x: hidden;
        }

        .hero-section {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0 20px;
        }

        .converters-container {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 10vw;
          margin-top: 33.33vh;
          margin-bottom: 33.33vh;
        }

        .converter-box {
          width: 33.33vh;
          height: 33.33vh;
          border-radius: 1.11vh;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          padding: 2.22vh;
          box-sizing: border-box;
        }

        .audio-box {
          background-color: #FF2D55;
        }

        .video-box {
          background-color: #5856D6;
        }

        .videotovideo-box {
          background-color: #007AFF;
        }

        .box-text {
          font-family: "DM Sans", sans-serif;
          font-optical-sizing: auto;
          font-weight: 400;
          font-style: normal;
          font-size: 2.59vh;
          color: white;
          letter-spacing: 1px;
          text-align: center;
          width: 100%;
        }

        .box-inner {
          width: 100%;
          height: 100%;
          border: 0px solid #E5E7EB;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        @media (max-height: 600px) {
          .converter-box {
            width: 200px;
            height: 200px;
          }
        }

        @media screen and (max-width: calc(119.99vh)) {
          .converters-container {
            grid-template-columns: 1fr;
            gap: 10vh;
            max-width: none;
            margin-top: 20vh;
          margin-bottom: 20vh;
          }

          .converter-box {
            width: 33.33vh;
            height: 33.33vh;
            justify-self: center;
          }

          .box-text {
            font-size: 2.59vh;
          }
        }

        @media screen and (max-width: 480px) {
          .converter-box {
            width: 250px;
            height: 250px;
          }
          
          .box-text {
            font-size: 18px;
          }
        }
      `}</style>
    </div>
  );
};

export default Home;